import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { X, Clock } from "lucide-react";

const COR = {
  violet: "bg-violet-500", emerald: "bg-emerald-500", blue: "bg-blue-500",
  amber: "bg-amber-500", green: "bg-green-500", cyan: "bg-cyan-500",
  indigo: "bg-indigo-500", slate: "bg-slate-400",
};

export const ProspectaTimelineModal = ({ open, onClose, lead }) => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && lead?.id) {
      setLoading(true);
      setEventos([]);
      axios
        .get(`${API}/prospecta/leads/${lead.id}/timeline`)
        .then((r) => setEventos(r.data.eventos || []))
        .catch(() => setEventos([]))
        .finally(() => setLoading(false));
    }
  }, [open, lead]);

  if (!open) return null;

  const fmt = (ts) => {
    try {
      return new Date(ts).toLocaleString("pt-BR");
    } catch {
      return ts;
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="timeline-modal"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b bg-slate-50">
          <div className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-violet-600" />
            <div>
              <h3 className="font-semibold text-slate-800">Linha do Tempo</h3>
              <p className="text-xs text-slate-500">
                {lead?.nome} — {lead?.telefone}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-700"
            data-testid="timeline-close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto">
          {loading && <p className="text-sm text-slate-500">Carregando...</p>}
          {!loading && eventos.length === 0 && (
            <p className="text-sm text-slate-500">Nenhum evento registrado ainda.</p>
          )}
          <ol className="relative border-l-2 border-slate-200 ml-2">
            {eventos.map((e, i) => (
              <li key={i} className="mb-5 ml-5" data-testid={`timeline-event-${i}`}>
                <span
                  className={`absolute -left-[9px] w-4 h-4 rounded-full ring-4 ring-white ${
                    COR[e.cor] || COR.slate
                  }`}
                ></span>
                <p className="text-sm font-semibold text-slate-800">{e.titulo}</p>
                {e.descricao && <p className="text-xs text-slate-500">{e.descricao}</p>}
                <time className="text-[11px] text-slate-400">{fmt(e.timestamp)}</time>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ProspectaTimelineModal;
